(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderStars(value) {
    var rating = Math.max(0, Math.min(5, parseInt(value || 0, 10)));
    var html = '<div class="vstar-star normal">';
    var index;

    for (index = 1; index <= 5; index += 1) {
      html += '<span class="star-item' + (index > rating ? ' nostar' : '') + '"><svg class="trustoo-rating-icon loox-icon" viewBox="0 0 20 19" aria-hidden="true"><path d="M10 0L12.8214 6.11672L19.5106 6.90983L14.5651 11.4833L15.8779 18.0902L10 14.8L4.12215 18.0902L5.43493 11.4833L0.489435 6.90983L7.17863 6.11672L10 0Z"></path></svg></span>';
    }

    return html + '</div>';
  }

  function readSummary(root) {
    var script = root.querySelector('[data-grt-review-slider-summary]');

    if (!script) {
      return { count: 0, average: '--' };
    }

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return { count: 0, average: '--' };
    }
  }

  function updateSummary(root) {
    var ratingNode = root.querySelector('[data-grt-review-slider-rating]');
    var countNode = root.querySelector('[data-grt-review-slider-count]');
    var summary = readSummary(root);

    if (ratingNode) {
      ratingNode.textContent = summary.count ? summary.average : '--';
    }

    if (countNode) {
      countNode.textContent = summary.count ? summary.count + ' reviews' : '0 reviews';
    }
  }

  function mountModal(root) {
    var modal = root.querySelector('[data-grt-review-modal]');
    if (!modal) return function () {};

    var mediaNode = modal.querySelector('[data-grt-review-modal-media]');
    var ratingNode = modal.querySelector('[data-grt-review-modal-rating]');
    var nameNode = modal.querySelector('[data-grt-review-modal-name]');
    var textNode = modal.querySelector('[data-grt-review-modal-text]');
    var productNode = modal.querySelector('[data-grt-review-modal-product]');
    var cards = root.querySelectorAll('[data-grt-review-card]');
    var closeNodes = modal.querySelectorAll('[data-grt-review-modal-close]');

    function closeModal() {
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('grt_review_modal_open');
    }

    function openModal(card) {
      var imageUrl = card.getAttribute('data-review-image') || '';
      var productName = card.getAttribute('data-review-product') || '';
      var productUrl = card.getAttribute('data-review-product-url') || '';

      mediaNode.innerHTML = imageUrl
        ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(productName || 'Review image') + '" loading="eager" decoding="async">'
        : '';
      ratingNode.innerHTML = renderStars(card.getAttribute('data-review-rating'));
      nameNode.textContent = card.getAttribute('data-review-name') || '';
      textNode.textContent = card.getAttribute('data-review-text') || '';
      productNode.innerHTML = '';

      if (productName) {
        productNode.innerHTML += '<span class="grt-review-slider__modal-product-name">' + escapeHtml(productName) + '</span>';
      }

      if (productUrl) {
        productNode.innerHTML += '<a class="grt-review-slider__modal-product-link" href="' + escapeHtml(productUrl) + '">View product</a>';
      }

      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('grt_review_modal_open');
    }

    Array.prototype.forEach.call(cards, function (card) {
      card.addEventListener('click', function () {
        openModal(card);
      });
    });

    Array.prototype.forEach.call(closeNodes, function (node) {
      node.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.hasAttribute('data-grt-review-modal-close')) closeModal();
    });

    function handleEscape(event) {
      if (event.key === 'Escape') closeModal();
    }

    document.addEventListener('keydown', handleEscape);

    return function () {
      Array.prototype.forEach.call(closeNodes, function (node) {
        node.removeEventListener('click', closeModal);
      });
      document.removeEventListener('keydown', handleEscape);
      closeModal();
    };
  }

  function mountMarquee(root) {
    var list = root.querySelector('[data-grt-review-slider-list]');
    var slides = Array.prototype.slice.call(list.querySelectorAll('.grt-review-slider__slide'));
    var autoplayEnabled = String(root.getAttribute('data-grt-review-slider-autoplay') || 'true').toLowerCase() === 'true';
    var direction = String(root.getAttribute('data-grt-review-slider-direction') || 'left').toLowerCase();
    var speedSetting = parseFloat(root.getAttribute('data-grt-review-slider-speed') || '4');
    var marqueeStep = Math.max(0.2, speedSetting * 0.18);
    var marqueeOffset = 0;
    var marqueeFrame = null;
    var marqueePaused = !autoplayEnabled;
    var marqueeResetPoint = 0;

    updateSummary(root);

    if (!slides.length) {
      root.classList.add('grt-review-slider--no-results');
      return;
    }

    root.classList.remove('grt-review-slider--pending');

    if (slides.length > 1) {
      list.insertAdjacentHTML('beforeend', list.innerHTML);
      root.classList.add('grt-review-slider--marquee');
    }

    function normalizeOffset(offset) {
      if (marqueeResetPoint <= 0) return 0;

      if (offset >= marqueeResetPoint) {
        return offset % marqueeResetPoint;
      }

      if (offset < 0) {
        return marqueeResetPoint + (offset % marqueeResetPoint);
      }

      return offset;
    }

    function applyTransform() {
      list.style.transform = 'translate3d(-' + marqueeOffset + 'px, 0, 0)';
    }

    function measureMarquee() {
      marqueeResetPoint = slides.length > 1 ? list.scrollWidth / 2 : 0;
      marqueeOffset = normalizeOffset(marqueeOffset);

      if (direction === 'right' && marqueeOffset === 0 && marqueeResetPoint > 0) {
        marqueeOffset = marqueeResetPoint / 2;
      }

      applyTransform();
    }

    function tickMarquee() {
      if (!marqueePaused && marqueeResetPoint > 0) {
        marqueeOffset += direction === 'right' ? -marqueeStep : marqueeStep;
        marqueeOffset = normalizeOffset(marqueeOffset);
        applyTransform();
      }

      marqueeFrame = window.requestAnimationFrame(tickMarquee);
    }

    function pauseMarquee() {
      marqueePaused = true;
    }

    function resumeMarquee() {
      marqueePaused = !autoplayEnabled;
    }

    function releasePointer() {
      delete list.dataset.pointerStartX;
      delete list.dataset.pointerStartOffset;
      marqueePaused = !autoplayEnabled;
    }

    root.addEventListener('mouseenter', pauseMarquee);
    root.addEventListener('mouseleave', resumeMarquee);

    list.addEventListener('pointerdown', function (event) {
      marqueePaused = true;
      list.dataset.pointerStartX = String(event.clientX || 0);
      list.dataset.pointerStartOffset = String(marqueeOffset);
    });

    list.addEventListener('pointermove', function (event) {
      var pointerStartX = parseFloat(list.dataset.pointerStartX || '');
      var pointerStartOffset = parseFloat(list.dataset.pointerStartOffset || '');

      if (!isFinite(pointerStartX) || !isFinite(pointerStartOffset)) return;

      marqueeOffset = normalizeOffset(pointerStartOffset - (event.clientX - pointerStartX));
      applyTransform();
    });

    list.addEventListener('pointerup', releasePointer);
    list.addEventListener('pointercancel', releasePointer);
    list.addEventListener('pointerleave', releasePointer);

    window.addEventListener('resize', measureMarquee);

    measureMarquee();

    if (slides.length > 1) {
      marqueeFrame = window.requestAnimationFrame(tickMarquee);
    }

    var cleanupModal = mountModal(root);

    root._grtReviewSliderCleanup = function () {
      if (marqueeFrame !== null) {
        window.cancelAnimationFrame(marqueeFrame);
        marqueeFrame = null;
      }
      window.removeEventListener('resize', measureMarquee);
      root.removeEventListener('mouseenter', pauseMarquee);
      root.removeEventListener('mouseleave', resumeMarquee);
      cleanupModal();
    };
  }

  function initSlider(root) {
    if (!root || root.dataset.grtReviewSliderReady === 'true') return;
    if (!root.id || root.id !== 'grt-review-slider-' + root.getAttribute('data-grt-review-slider-id')) return;
    root.dataset.grtReviewSliderReady = 'true';
    mountMarquee(root);
  }

  function destroySlider(root) {
    if (!root) return;
    if (typeof root._grtReviewSliderCleanup === 'function') {
      root._grtReviewSliderCleanup();
      delete root._grtReviewSliderCleanup;
    }
    delete root.dataset.grtReviewSliderReady;
  }

  function initAllSliders(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-grt-review-slider]');
    Array.prototype.forEach.call(roots, initSlider);
  }

  function destroyAllSliders(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-grt-review-slider]');
    Array.prototype.forEach.call(roots, destroySlider);
  }

  window.addEventListener('load', function () {
    initAllSliders(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAllSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    destroyAllSliders(event.target);
  });
})();
